import {Button, Divider, Flex, Input, Modal} from "antd";
import React, {useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";
import Password from "antd/es/input/Password";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {fetchUser, signup} from "../../feature/project/userSlice";
import md5 from "md5";

export const Register = () => {
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [password2, setPassword2] = React.useState('')
    const error = useAppSelector(state => state.users.error)
    const user = useAppSelector(state => state.users.currentUser)
    const [code, setCode] = React.useState('')
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = React.useState(false)

    useEffect(() => {
        console.log(error)
    }, [error]);

    useEffect(() => {
        if (user) {
            navigate('/')
        }
    }, [user]);

    useEffect(() => {
        dispatch(fetchUser())
    }, []);

    return (
        <div style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: 'url(/images/back1.jpg)',
            width: '100%',
            height: '100%'
        }}>
            <Modal
                title=""
                open={true}
                centered={true}
                okButtonProps={{style: {display: 'none'}}}
                cancelButtonProps={{style: {display: 'none'}}}
                closable={false}
                mask={false}
                width={350}
            >
                <Flex vertical={true} gap={10} align={'center'}>
                    <Divider>
                        <img alt={'logo'} src={'/logo.svg'} style={{width: 32}}/>
                    </Divider>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>E-mail</b></div>
                        <Input value={email} type={'email'} onChange={(e) => setEmail(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>Password</b></div>
                        <Password value={password} onChange={(e) => setPassword(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>Confirm Password</b></div>
                        <Password value={password2} onChange={(e) => setPassword2(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>Invitation Code</b></div>
                        <Input value={code} onChange={(e) => setCode(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%', marginTop: 20}} vertical={true} align={'center'}>
                        <Button
                            style={{width: 200}}
                            type={'primary'}
                            loading={loading}
                            disabled={password !== password2 || email.length === 0 || password.length === 0 || code.length === 0}
                            onClick={() => {
                                setLoading(true)
                                dispatch(signup({email: email, hash: md5(password), code: code}))
                                    .finally(() => setLoading(false))
                            }}
                        >Sign-up</Button>
                        <Divider>OR</Divider>
                        <Button style={{width: 200}} type={'text'}
                                onClick={() => navigate('/sign-in')}
                        >Back to Sign-in</Button>
                    </Flex>
                </Flex>
            </Modal>
        </div>
    )
}